/// <reference path="../app.ts" />

namespace Cfnc {

    export interface IResponseInterceptor {
        response: (response) => ng.IPromise<any>;
        responseError: (rejection) => ng.IPromise<any>;
    }

    export class ResponseInterceptor implements IResponseInterceptor {
        static serviceId: string = "responseInterceptor";

        four0oneCount = 0; 
        common: ICommonFactory;

        constructor(private $q: ng.IQService, private $injector: ng.auto.IInjectorService, private httpBuffer: IHttpBuffer) {
        }

        response = (response) => {
            this.four0oneCount = 0;
            return response;
        }

        responseError = (rejection) => {

            this.common = this.common || this.$injector.get("common") as ICommonFactory;

            var deferred = this.$q.defer();

            if (rejection.status === 401) {
                if (this.four0oneCount >= 10) {
                    this.common.authentication.silentLogout().then(() => {
                        this.common.authentication.login();
                    });
                }

                this.four0oneCount += 1;

                var authService: Security.IAuthenticationService = this.$injector.get("authentication") as Security.IAuthenticationService;

                authService.authenticate(true).then(() => {
                    this.httpBuffer.append(rejection.config, deferred);
                    this.httpBuffer.retryAll(config => {
                        return config;
                    });
                })
            }
            else {
                deferred.reject(rejection);
            }

            return deferred.promise;

        }
    }

    angular.module("app").factory(ResponseInterceptor.serviceId,
        ["$q", "$injector", "httpBuffer", ($q, $injector, httpBuffer, common) => new ResponseInterceptor($q, $injector, httpBuffer)]);
}
